module.exports = __webpack_public_path__ + "static/img/cygn1.d99012c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn1.png
// module id = 309
// module chunks = 0